// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3AWNU","productName":"Table_productName__3mmVA"};